import styled from 'styled-components'

export const Title = styled.div`
  color: #000000;
  font-size: 40px;
  font-weight: 600;
  line-height: 45px;
  margin-bottom: 27px;
`
